<template>
    <div>
            <!--Content Wrap Start-->
    <div class="kode_content">
    
        <section>
        	<div class="container" style="padding-top:5%">
            	<div class="row">
                	<!--News Deatail Wrap Start-->
                	<div class="col-md-8">
                    	<div class="kode_news_detail">
                        	<figure>
                            	<img :src="file_path+foto" alt="Image Here" style="display: block;width: 100% !important;height: 500px !important">
                            </figure>
                            <h4>{{judul}}</h4>
                            <ul>
                            	<li>by <a href="#"> <span>{{createBy}} </span> </a> <i class="fa fa-calendar"></i>{{convert_tgl(createAt)}}</li>
                                <!-- <li> <a href="#"> <i class="fa fa-heart-o"></i>144 </a> </li>
                                <li> <a href="#"> <i class="fa fa-comment-o"></i>49 </a> </li>
                                <li> <a href="#"> <i class="fa fa-eye"></i>12,998 </a> </li> -->
                            </ul>
                            <p v-html="isi"></p>
                            
                         
                        </div>
                        
                        <!--Recommended For You Wrap Start-->
                        <!-- <div class="kode_related_event">
                            <h6>Berita Disarankan</h6>
                            <div class="row">

                                <div class="col-md-4">
                                    <div class="kode_event_list">
                                        <figure>
                                            <img src="extra-images/related-event-01.jpg" alt="Image Here">
                                        </figure>
                                        <router-link to="/isi_berita">Election Campaign</router-link>
                                    </div>
                                </div>


                          
                                
 
                                
                            </div>
                        </div> -->
                        <!--Recommended For You Wrap End-->
						
						<!--Next and Previous Wrap Start-->
						<!-- <div class="kf_pagination">
							<ul class="pagination">
								<li class="pull-left"> <a aria-label="Previous" href="#"><b>« Berita Sebelumnya</b></a></li>
								<li class="pull-right"> <a aria-label="Next" href="#"><b> Berita Selanjutnya »</b></a></li>
							</ul>
						</div> -->
						<!--Next and Previous Wrap End-->
                        
 
                        
 
                        
                    </div>
                    <!--News Deatail Wrap End-->
                    
                    <!--Aside Wrap Start-->
                    <div class="col-md-4">
      
                        
 
                        
                        <div class="kode_aside_event kode_aside">
                        	<h5>Kegiatan</h5>
                            <ul>
                            	<li v-for="data in kegiatan" :key="data.id">
                                	<figure>
                                    	<img :src="file_path+data.foto" alt="Image Here">
                                        <figcaption>
                                         
                                            <a href="javascript:void(0);" @click="push_kegiatan(data.id)"><i class="fa fa-link"></i></a>
                                        </figcaption>
                                    </figure>
                                    <div class="kode_aside_event_des" style="text-align:justify">
                                    	<p v-html="limit_desk_kegiatan(data.deskripsi) + ' ...'"> </p>
                                    	<span><b>{{convert_tgl(data.createAt)}}</b></span>
                                    </div>
                                </li>
                                
 
                            </ul>
                        </div>
                        
 
                        
                        <!--Aside Calender Wrap Start-->
                        <div class="kode_calender kode_aside">
							<div id='calendar'></div>
						</div>
                        <!--Aside Calender Wrap End-->
                        
                        <div class="kode_aside_flicker kode_aside">
                        	<h5>Galleri Kegiatan</h5>
                        	<ul>
                            	<li v-for="data in kegiatan6" :key="data.id">
                                	<a href="javascript:void(0);" @click="push_kegiatan(data.id)">
                                		<figure>
                                    		<img :src="file_path+data.foto" alt="Image Here" style="height:90px;width:100%">
                                            <figcaption>
                                            	<i class="fa fa-plus"> </i>
                                            </figcaption>
                                    	</figure>
                                	</a>
                                </li>
                                
 
                            </ul>
                        </div>
                        
                    </div>
                    <!--Aside Wrap End-->
                    
                </div>
            </div>
        </section>
        
    </div>
    <!--Content Wrap End-->
    </div>
</template>



<script>




const ADD_URL = URL_APP + "api/v1/publish_berita/";
const KEGIATAN_URL = URL_APP + "api/v1/publish_kegiatan/";



const FILE_LOAD = URL_APP+'uploads/';

export default {
  name: "web_pengumuman",
//   title: "My page title",
  data() {
    return {
        id : this.$route.params.id,
        createAt : '',
        createBy : '',
        deskripsi : '',
        isi : '',
        judul : '',
        sumber : '',
        foto : '',
        kegiatan:[],
        kegiatan6:[],


		
        HOST : URL_HOST+this.$route.fullPath,
        hest : 'http://twitter.com',
		file_path : FILE_LOAD,

    //   list_data: [],
    //   page_first: 1,
    //   page_last: 0,
    //   cari_value: ""
    };
  },

  // =============================================================== METHODS =========================================================================
  methods: {

	getView: function() {
      fetch(ADD_URL + "isi_berita", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          id: this.$route.params.id,
        })
      })
        .then(res => res.json())
        .then(res_data => {
          var berita = res_data[0];

            this.createAt = berita.createAt;
            this.createBy = berita.createBy;
            this.deskripsi = berita.deskripsi;
            this.isi = berita.isi;
            this.judul = berita.judul;
            this.sumber = berita.sumber;
            this.foto = berita.foto;    

        //   console.log(berita);
       });
    },

    getKegiatan: function() {
        fetch(KEGIATAN_URL + "getOne", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
            .then(res => res.json())
            .then(res_data => {
                this.kegiatan = res_data;
                //   console.log(res_data);
            });
    },    

        getKegiatan6: function() {
        fetch(KEGIATAN_URL + "get6", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
            .then(res => res.json())
            .then(res_data => {
                this.kegiatan6 = res_data;
                //   console.log(res_data);
            });
    },     

    limit_desk_kegiatan : function(text){
    return text.substring(0, 100)
    }, 

	push_kegiatan : function(id){
		this.$router.push('/isi_kegiatan/'+id);
    },
        

    to_facebook : function () {
        window.open("http://www.facebook.com/sharer.php?u="+this.HOST, '_blank');
    },
    to_twitter : function(){
        // alert(this.HOST)
        window.open("https://twitter.com/share?url="+this.HOST+"&amp;text="+this.judul, '_blank');
    },







    // ================== PAGINASI ====================
        alertku: function(type, title) {
        this.$swal({
            type: type,
            title: title,
            showConfirmButton: false,
            timer: 800
        });
        },

        btn_prev: function() {
        if (this.page_first > 1) {
            this.page_first--;
        } else {
            this.page_first = 1;
        }
        this.getView();
        },

        btn_next: function() {
        if (this.page_first >= this.page_last) {
            this.page_first == this.page_last;
        } else {
            this.page_first++;
        }
        this.getView();
        },

        cari_data: function() {
          this.getView();
        },
        onFileSelected : function(event){
            this.foto = event.target.files[0];
            console.log(this.foto);
        },
        convert_tgl : function(dateString){
			var date = new Date(dateString);
			var bulan = "";

			if (date.getMonth() == 0) {bulan = 'januari';} 
			else if (date.getMonth() == 1) {bulan = 'Februari';}
			else if (date.getMonth() == 2) {bulan = 'Maret';}
			else if (date.getMonth() == 3) {bulan = 'April';}
			else if (date.getMonth() == 4) {bulan = 'Mei';}
			else if (date.getMonth() == 5) {bulan = 'Juni';}
			else if (date.getMonth() == 6) {bulan = 'Juli';}
			else if (date.getMonth() == 7) {bulan = 'Agustus';}
			else if (date.getMonth() == 8) {bulan = 'September';}
			else if (date.getMonth() == 9) {bulan = 'Oktober';}
			else if (date.getMonth() == 10) {bulan = 'November';}
			else if (date.getMonth() == 11) {bulan = 'Desember';}
			else{bulan = ''}

          return date.getDate()+" "+bulan+" "+date.getFullYear();
        },
    // ================== PAGINASI ====================
  },
  // =============================================================== METHODS =========================================================================

  mounted() {
    this.getView();
    // alert(this.$route)
    // console.log(this.HOST);
    this.getKegiatan();
	this.getKegiatan6();
  },

};



</script>


